module.exports = __webpack_public_path__ + "static/media/48.89c72c38.jpg";